// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoRedshift } from '../../../assets/images/Logos/logo-redshift.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoRedshiftIcon = /* @__PURE__ */ withLogoClass(LogoRedshift);
